package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.MERCHANT_LOGIN
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class LoginMerchantRequestModel(
    val email: String,
    val password: String
) : BaseRequestModel(api = MERCHANT_LOGIN)

